module.exports = __webpack_public_path__ + "static/media/Legal Assistance.671b3528.png";